import TitleComp from './Title';
export default TitleComp;
